import { IVdoMenuItem } from '../interfaces/vdo-menu-item.interface';

export class VdoSidebarHelper {
  /**
   * Derives the menu based on a list of allowed IDs
   * @param menu Original menu
   * @param allowedIds List of allowed IDs or 'all' to allow all
   * @returns Menu with updated isAllowed properties
   */
  static deriveMenuBasedOnAllowedIds(
    menu: IVdoMenuItem[],
    allowedIds: string[] | 'all'
  ): IVdoMenuItem[] {
    return menu.map(menuItem => {
      const clonedMenuItem = { ...menuItem };

      if (allowedIds === 'all') {
        clonedMenuItem.isAllowed = true;
        clonedMenuItem.children = menuItem.children?.map(child => ({
          ...child,
          isAllowed: true,
        }));
      } else {
        clonedMenuItem.isAllowed = allowedIds.includes(menuItem.id);

        clonedMenuItem.children = menuItem.children?.map(child => ({
          ...child,
          isAllowed: allowedIds.includes(child.id),
        }));
      }

      return clonedMenuItem;
    });
  }

  /**
   * Filters the menu by removing non-permitted items
   * @param menu Menu with isAllowed properties defined
   * @returns Filtered menu with only permitted items
   */
  static filterMenuByAllowed(menu: IVdoMenuItem[]): IVdoMenuItem[] {
    return menu.filter(menuItem => {
      if (!menuItem.isAllowed) {
        return false;
      }

      if (menuItem.children?.length) {
        const allowedChildren = menuItem.children.filter(child => child.isAllowed);

        if (allowedChildren.length === 0) {
          return false;
        }

        menuItem.children = allowedChildren;
      }

      return true;
    });
  }
}
